import EmailOptInFormEntryGenerated, { EmailOptInFormEntryGeneratedEntityManager } from './generated/EmailOptInFormEntry.generated';
import client from '@xFrame4/business/GraphQlClient';


export class EmailOptInFormEntryEntityManager extends EmailOptInFormEntryGeneratedEntityManager<EmailOptInFormEntry>
{
    constructor()
    {
        super({
            createEntity: () => new EmailOptInFormEntry(),
        });
    }
}


/**
 * EmailOptInFormEntry
 * 
 * Read this document on how to work with TypeScript business entities: .cursor/rules/xapp-ts-business-entity-rules.mdc
 */
export class EmailOptInFormEntry extends EmailOptInFormEntryGenerated
{
    static _manager: EmailOptInFormEntryEntityManager;
    static get manager(): EmailOptInFormEntryEntityManager
    {
        if (!this._manager) this._manager = new EmailOptInFormEntryEntityManager();

        return this._manager;
    }

    /**
     * Marks an email opt-in form entry as confirmed using the confirmation token.
     * Uses the mark_email_opt_in_form_entry_as_confirmed mutation.
     * Returns an object with success status, redirect URL, form ID, the entry object, and already_confirmed flag.
     */
    static async markAsConfirmed(confirmationToken: string): Promise<{success: boolean, redirectUrl: string | null, formId: number | null, entry: EmailOptInFormEntry | null, alreadyConfirmed: boolean}>
    {
        let { gql } = await import('@apollo/client');

        let mutation = `
            mutation MarkEmailOptInFormEntryAsConfirmed($confirmationToken: String!) {
                markEmailOptInFormEntryAsConfirmed(confirmationToken: $confirmationToken) {
                    success
                    redirectUrl
                    formId
                    alreadyConfirmed
                    entry {
                        id
                        email
                        name
                        phone
                        language
                        isConfirmed
                        dateConfirmed
                        dateCreated
                    }
                }
            }
        `;

        let variables = {
            confirmationToken: confirmationToken
        };

        try
        {
            let { data } = await client.mutate({
                mutation: gql(mutation),
                variables: variables
            });

            let entry: EmailOptInFormEntry | null = null;
            if (data?.markEmailOptInFormEntryAsConfirmed?.entry)
            {
                entry = EmailOptInFormEntry.createFromGraphQL(data.markEmailOptInFormEntryAsConfirmed.entry) as EmailOptInFormEntry;
            }

            return {
                success: data?.markEmailOptInFormEntryAsConfirmed?.success ?? false,
                redirectUrl: data?.markEmailOptInFormEntryAsConfirmed?.redirectUrl ?? null,
                formId: data?.markEmailOptInFormEntryAsConfirmed?.formId ?? null,
                entry: entry,
                alreadyConfirmed: data?.markEmailOptInFormEntryAsConfirmed?.alreadyConfirmed ?? false
            };
        }
        catch (error)
        {
            console.error('Error marking email opt-in form entry as confirmed:', error);

            return {
                success: false,
                redirectUrl: null,
                formId: null,
                entry: null,
                alreadyConfirmed: false
            };
        }
    }
}


export default EmailOptInFormEntry;